module.exports = __webpack_public_path__ + "img/sendhappyness.512dc725.png";